var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchInput"},[_c('UiInputText',_vm._g(_vm._b({attrs:{"placeholder":"Поиск","type":"text"}},'UiInputText',_vm.$attrs,false),_vm.listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }